import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Grid, Divider } from '@mui/material';
import { toast } from "react-toastify";
import { apiURL, GetAll } from '../../../utils/apiCalls';

const Analytics = () => {
  const [analytics, setAnalytics] = useState({});

  async function GetList() {
    const response = await GetAll(apiURL + '/api/v1/users/get/analytics_by_agent');
    if (response) {
      if (response.data.status) {
        setAnalytics(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    }
  }

  useEffect(() => {
    GetList();
  }, []);

  const sections = {
    "Procurement Performance": [
      "procurement_today",
      "procurement_week",
      "procurement_month",
      "procurement_year",
      "procurement_total",
      "procurement_amount_today",
      "procurement_amount_week",
      "procurement_amount_month",
      "procurement_amount_year",
      "procurement_amount_total",
    ],
    "Associate Performance": [
      "associate_today",
      "associate_week",
      "associate_month",
      "associate_year",
      "associate_total",
      "associate_amount_today",
      "associate_amount_week",
      "associate_amount_month",
      "associate_amount_year",
      "associate_amount_total",
    ],
    "99 Plan": [
      "associate_99_subscription_today",
      "associate_99_subscription_week",
      "associate_99_subscription_month",
      "associate_99_subscription_year",
      "associate_99_subscription_total",
      "associate_99_amount_today",
      "associate_99_amount_week",
      "associate_99_amount_month",
      "associate_99_amount_year",
      "associate_99_amount_total",
    ],
    "179 Plan": [
      "associate_179_subscription_today",
      "associate_179_subscription_week",
      "associate_179_subscription_month",
      "associate_179_subscription_year",
      "associate_179_total",
      "associate_179_amount_today",
      "associate_179_amount_week",
      "associate_179_amount_month",
      "associate_179_amount_year",
      "associate_179_amount_total",
    ],
    "259 Plan": [
      "associate_259_subscription_today",
      "associate_259_subscription_week",
      "associate_259_subscription_month",
      "associate_259_subscription_year",
      "associate_259_total",
      "associate_259_amount_today",
      "associate_259_amount_week",
      "associate_259_amount_month",
      "associate_259_amount_year",
      "associate_259_amount_total",
    ],
    "299 Plan": [
      "associate_299_subscription_today",
      "associate_299_subscription_week",
      "associate_299_subscription_month",
      "associate_299_subscription_year",
      "associate_299_subscription_total",
      "associate_299_amount_today",
      "associate_299_amount_week",
      "associate_299_amount_month",
      "associate_299_amount_year",
      "associate_299_amount_total",
    ],
    "2499 Plan": [
      "associate_2499_subscription_today",
      "associate_2499_subscription_week",
      "associate_2499_subscription_month",
      "associate_2499_subscription_year",
      "associate_2499_subscription_total",
      "associate_2499_amount_today",
      "associate_2499_amount_week",
      "associate_2499_amount_month",
      "associate_2499_amount_year",
      "associate_2499_amount_total",
    ],
  };

  const formatKey = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <Box>
      <Typography variant="h4" mb={2}>
        Analytics Dashboard
      </Typography>

      {Object.entries(sections).map(([sectionTitle, keys]) => (
        <Box key={sectionTitle} mb={4}>
          <Typography variant="h6" mb={1}>
            {sectionTitle}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            {keys.map((key) => (
<Grid item xs={6} sm={4} md={2} key={key}>
  <Card 
    sx={{ 
      borderRadius: 2, 
      minHeight: 90, 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center",
      p: 1
    }}
  >
    <CardContent sx={{ p: 1, textAlign: "center" }}>
      <Typography 
        variant="caption" 
        color="text.secondary" 
        sx={{ fontSize: "0.75rem" }}
      >
        {formatKey(key)}
      </Typography>

      <Typography 
        variant="h6" 
        fontWeight={700} 
        sx={{ fontSize: "1rem", mt: 0.5 }}
      >
        {analytics[key] ?? 0}
      </Typography>
    </CardContent>
  </Card>
</Grid>

            ))}
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default Analytics;
